import { render, staticRenderFns } from "./OverDueInstallments.vue?vue&type=template&id=8149845c"
import script from "./OverDueInstallments.vue?vue&type=script&lang=js"
export * from "./OverDueInstallments.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports